// Non-translatable assets + nav anchor ids for Boreal Coco.
export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1641266886439-4fe7852df25c",
  grow: "https://images.unsplash.com/photo-1693414854278-6b3703411629",
  industrial: "https://images.unsplash.com/photo-1553787434-dd9eb4ea4d0b",
  logistics: "https://images.pexels.com/photos/262353/pexels-photo-262353.jpeg",
  problock: "https://static.prod-images.emergentagent.com/jobs/c4ca7fd5-0cac-4447-a9b5-fa24bb6dc915/images/c87296d334a007ed436b7eaee40041d7883b04a8f12789a820f42b752a56fc9c.png",
  hydrobuffer: "https://static.prod-images.emergentagent.com/jobs/c4ca7fd5-0cac-4447-a9b5-fa24bb6dc915/images/34103306f63d5a99f821908c7e378d3641f0d2bf1b05e8b6727c8c6fd1d84227.png",
  cococoins: "https://customer-assets.emergentagent.com/job_coco-connect-1/artifacts/q34ytasf_Coco%20coins.jpeg",
  food: "https://static.prod-images.emergentagent.com/jobs/c4ca7fd5-0cac-4447-a9b5-fa24bb6dc915/images/6224b5b0b7b6887d6d0cd0f1e5dce6a1816651a2728aa2a1d4fd1a580740fcb1.png",
  retail: "https://static.prod-images.emergentagent.com/jobs/c4ca7fd5-0cac-4447-a9b5-fa24bb6dc915/images/4a91bc56aa5e251feb5c6d1856b9a234c4763110e6d23674505c1acf094902ef.png",
};

// ids double as translation keys in t.nav
export const NAV_LINKS = [
  { id: "supply" },
  { id: "products" },
  { id: "wholesale" },
  { id: "sustainability" },
  { id: "contact" },
];
